module.exports = __webpack_public_path__ + "static/media/Press-2.9a581c34.png";